const navbar = () => {
  document.addEventListener("DOMContentLoaded", () => {
    // Dropdown menu toggle on click
    document.body.addEventListener("click", (event) => {
      if (event.target.closest(".menu-item .material-symbols-outlined")) {
        const dropdownMenu = event.target.nextElementSibling;
        if (dropdownMenu && dropdownMenu.classList.contains("dropdown-menu")) {
          dropdownMenu.classList.toggle("d-none");
        }
      }
    });

    // Dropdown menu show/hide on hover (Only for screens wider than 990px)
    if (window.innerWidth > 990) {
      document.querySelectorAll(".dropdown").forEach((dropdown) => {
        dropdown.addEventListener("mouseenter", () => {
          const menu = dropdown.querySelector(".dropdown-menu");
          if (menu) menu.classList.remove("d-none");
        });

        dropdown.addEventListener("mouseleave", () => {
          const menu = dropdown.querySelector(".dropdown-menu");
          if (menu) menu.classList.add("d-none");
        });
      });
    }

    // Navbar toggler click event
    const toggler = document.querySelector(".navbar-toggler");
    const offcanvas = document.getElementById("navbarToggler");
    if (toggler && offcanvas) {
      toggler.addEventListener("click", () => {
        toggler.classList.toggle("collapsed");
        offcanvas.classList.toggle("aperto");
        document.body.classList.toggle("noscroll");
      });
    }

    // Scroll event for sticky header
    window.addEventListener("scroll", () => {
      const scrollPosition = window.scrollY;
      const headerTop = document.querySelector(".header-top")?.offsetHeight || 0;

      if (scrollPosition > headerTop) {
        document.body.classList.add("stickyHeader");
      } else {
        document.body.classList.remove("stickyHeader");
      }
    });

    const menuDesktop = document.querySelector("#menu-desktop-menu");
    if (menuDesktop) {
      navAnchor(menuDesktop);
    }

    const menuMain = document.querySelector("#menu-main-menu");
    if (menuMain) {
      navAnchor(menuMain, toggler, offcanvas);
    }

    // Smooth Scroll on Page Load if there's a hash in the URL
    if (window.location.hash) {
      const targetId = window.location.hash.substring(1);
      scrollToElement(targetId);
    }
  });
};

export default navbar;

const scrollToElement = (targetId) => {
  const targetElement = document.getElementById(targetId);
  if (targetElement) {
    setTimeout(() => {
      const header = document.querySelector(".header");
      const headerHeight = header ? header.offsetHeight : 0;
      window.scrollTo({
        top: targetElement.getBoundingClientRect().top + window.scrollY - headerHeight,
        behavior: "smooth",
      });
    }, 300); // Delay to ensure elements are loaded
  }
};

const navAnchor = (menu, toggler = null, offcanvas = null) => {
  let baseUrl = window.location.origin;
  baseUrl += window.location.host != "localhost" ? "/" : "/claudialeidi/";
  const links = menu.querySelectorAll('a[href^="#"]');
  if (links.length > 0) {
    links.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();

        if (toggler && offcanvas) {
          // Close offcanvas if open
          toggler.classList.add("collapsed");
          offcanvas.classList.remove("aperto");
          document.body.classList.remove("noscroll");
        }

        const targetId = link.getAttribute("href").substring(1);
        if (window.location.href !== baseUrl) {
          window.location.href = baseUrl + "#" + targetId;
        } else {
          scrollToElement(targetId);
        }
      });
    });
  }
};
